export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-ivory py-28 md:py-40 lg:py-48 px-6 md:px-12 lg:px-20"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 lg:gap-x-20">
          {/* left rail */}
          <div className="lg:col-span-4 reveal">
            <p
              data-testid="about-overline"
              className="text-[10px] uppercase tracking-[0.32em] text-teal mb-8"
            >
              The Mission · 001
            </p>
            <h2
              data-testid="about-pullquote"
              className="font-serif font-light text-3xl md:text-4xl lg:text-5xl leading-[1.08] tracking-tight text-ink"
            >
              Curiosity over
              <br />
              limitation —
              <br />
              <em className="italic text-gold">
                musically and personally.
              </em>
            </h2>
            <div className="ink-divider mt-10" />
          </div>

          {/* body copy */}
          <div className="lg:col-span-7 lg:col-start-6 lg:pt-12 reveal">
            <div
              data-testid="about-body"
              className="space-y-7 text-ink/80 font-light text-lg md:text-xl leading-[1.75] max-w-[58ch]"
            >
              <p>
                A Wider Horizon is the personal music project of songwriter,
                producer, and multi-instrumentalist{" "}
                <span className="text-ink font-normal">Jacob Seal</span>. While
                the collaborators, vocalists, and genres may evolve from
                release to release, the project remains guided by a singular
                creative vision — rooted in human experience, emotional
                honesty, and artistic exploration.
              </p>
              <p>
                Built on the belief that growth begins beyond the familiar,
                A Wider Horizon embraces curiosity over limitation — both
                musically and personally. It is a project shaped by movement,
                reflection, and the pursuit of new perspectives.
              </p>
              <p className="text-ink">
                When the world begins to feel smaller, one can always search
                for a wider horizon.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
